import { Link } from 'react-router-dom';
import RoiCtaStrip from '@/components/feature/RoiCtaStrip';

interface ClusterPage {
  label: string;
  to: string;
  icon: string;
  description: string;
}

const encyclopediaCluster: ClusterPage[] = [
  {
    label: 'Что такое корпоративное обучение',
    to: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie',
    icon: 'ri-book-open-line',
    description: 'Базовое руководство по организации обучения в компании: виды, форматы, преимущества и ключевые метрики.',
  },
  {
    label: 'Обучение персонала',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-personala',
    icon: 'ri-user-star-line',
    description: 'Системный подход к обучению сотрудников: от диагностики потребностей до измерения результатов.',
  },
  {
    label: 'Обучение отдела продаж',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh',
    icon: 'ri-line-chart-line',
    description: 'Тренинги и методики для роста конверсии, повышения среднего чека и построения долгосрочных отношений с клиентами.',
  },
  {
    label: 'Тренинг для руководителей',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
    icon: 'ri-shield-star-line',
    description: 'Развитие управленческих компетенций: лидерство, принятие решений, мотивация команды и стратегическое мышление.',
  },
  {
    label: 'Развитие Soft Skills',
    to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
    icon: 'ri-chat-smile-3-line',
    description: 'Эмоциональный интеллект, коммуникации, тайм-менеджмент и адаптивность — ключевые гибкие навыки.',
  },
  {
    label: 'Командообразование',
    to: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie',
    icon: 'ri-group-line',
    description: 'Современные методики тимбилдинга: бизнес-игры, стратегические сессии и программы сплочения коллектива.',
  },
  {
    label: 'Адаптация сотрудников',
    to: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov',
    icon: 'ri-user-add-line',
    description: 'Построение эффективной программы онбординга: снижение текучести, ускорение выхода на продуктивность.',
  },
  {
    label: 'Корпоративная академия',
    to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya',
    icon: 'ri-building-line',
    description: 'Создание внутреннего учебного центра компании: структура, программы, оценка и развитие талантов.',
  },
  {
    label: 'Оценка эффективности обучения',
    to: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya',
    icon: 'ri-bar-chart-box-line',
    description: 'Модель Киркпатрика, расчёт ROI обучения, метрики и инструменты для измерения результативности.',
  },
  {
    label: 'Разработка программ обучения',
    to: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya',
    icon: 'ri-settings-3-line',
    description: 'Проектирование корпоративных программ под задачи бизнеса: от анализа потребностей до внедрения.',
  },
];

const salesCluster: ClusterPage[] = [
  {
    label: 'Тренинг по продажам',
    to: '/prodazhi-i-peregovory/trening-po-prodazham',
    icon: 'ri-line-chart-line',
    description: 'Корпоративное обучение продажам: от диагностики до роста конверсии.',
  },
  {
    label: 'Тренинг по переговорам',
    to: '/prodazhi-i-peregovory/trening-po-peregovoram',
    icon: 'ri-discuss-line',
    description: 'Эффективные переговоры: стратегии, влияние, достижение соглашений.',
  },
  {
    label: 'Холодные звонки',
    to: '/prodazhi-i-peregovory/trening-po-holodnym-zvonkam',
    icon: 'ri-phone-find-line',
    description: 'Обучение холодным звонкам: от страха до уверенных встреч с ЛПР.',
  },
  {
    label: 'Телефонные продажи',
    to: '/prodazhi-i-peregovory/trening-po-telefonnym-prodazham',
    icon: 'ri-phone-line',
    description: 'Эффективные техники телефонных продаж в современном мире мессенджеров.',
  },
  {
    label: 'Выявление потребностей',
    to: '/prodazhi-i-peregovory/trening-po-vyyavleniyu-potrebnostey',
    icon: 'ri-search-eye-line',
    description: 'Методики выявления истинных потребностей клиента: вопросы, анализ, глубинные мотивы.',
  },
  {
    label: 'Работа с возражениями',
    to: '/prodazhi-i-peregovory/trening-po-rabote-s-vozrazheniyami',
    icon: 'ri-chat-check-line',
    description: 'Техники обработки возражений и превращения их в возможности для продажи.',
  },
  {
    label: 'Работа с клиентами',
    to: '/prodazhi-i-peregovory/trening-po-rabote-s-klientami',
    icon: 'ri-customer-service-2-line',
    description: 'Обучение, которое соединяет продажи, коммуникацию, сервис, доверие и долгосрочные отношения.',
  },
  {
    label: 'B2B продажи',
    to: '/prodazhi-i-peregovory/trening-po-prodazham-b2b',
    icon: 'ri-building-2-line',
    description: 'Сложные продажи, работа с ЛПР, длинный цикл сделки и увеличение конверсии.',
  },
  {
    label: 'Продажи через переписку',
    to: '/prodazhi-i-peregovory/trening-po-prodazham-cherez-perepisku',
    icon: 'ri-chat-1-line',
    description: 'Обучение менеджеров продавать в Telegram, WhatsApp, CRM и e-mail.',
  },
];

interface ClusterRecommendationsProps {
  cluster: 'encyclopedia' | 'sales';
  currentPage: string;
  maxItems?: number;
}

export default function ClusterRecommendations({ cluster, currentPage, maxItems = 6 }: ClusterRecommendationsProps) {
  const pages = cluster === 'encyclopedia' ? encyclopediaCluster : salesCluster;
  const filtered = pages.filter((p) => p.to !== currentPage).slice(0, maxItems);

  if (filtered.length === 0) return null;

  const showRoiStrip = currentPage !== '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya';

  const title = cluster === 'encyclopedia'
    ? 'Рекомендуем изучить'
    : 'Рекомендуем изучить';

  const subtitle = cluster === 'encyclopedia'
    ? 'Другие материалы энциклопедии корпоративного обучения'
    : 'Другие программы по продажам и переговорам';

  return (
    <>
      {showRoiStrip && <RoiCtaStrip />}
      <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-3">
          {title}
        </h2>
        <p className="text-lg text-gray-600 text-center mb-10 max-w-3xl mx-auto">
          {subtitle}
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {filtered.map((item, i) => (
            <Link
              key={i}
              to={item.to}
              className="bg-gray-50 rounded-xl p-5 hover:bg-teal-50 hover:ring-2 hover:ring-teal-200 transition-all group cursor-pointer flex items-start gap-4"
            >
              <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-base text-white`}></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-sm mb-1 group-hover:text-teal-700 transition-colors">
                  {item.label}
                </h3>
                <p className="text-gray-600 text-xs leading-relaxed">{item.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
      </section>
    </>
  );
}